import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const FuelConsumptionChart = ({ data }) => (
  <>
    <ResponsiveContainer width="100%" height={300}>
      <BarChart
        data={data}
        margin={{ top: 20, right: 50, left: 50, bottom: 50 }}
      >
        <XAxis dataKey="mes" />
        <YAxis yAxisId="left" orientation="left" />
        <YAxis yAxisId="right" orientation="right" />
        <Tooltip />
        <Legend verticalAlign="top" />
        <Bar 
          yAxisId="left" 
          dataKey="litros" 
          fill="#152d51" 
          radius={[8, 8, 0, 0]} 
          name="Consumo (L)" 
        />
        <Bar 
          yAxisId="right" 
          dataKey="costo" 
          fill="#4F46E5" 
          radius={[8, 8, 0, 0]} 
          name="Costo ($)" 
        />
      </BarChart>
    </ResponsiveContainer>
    
    {/* Custom labels below the chart */}
    <div style={{ 
      display: "flex", 
      justifyContent: "space-between", 
      marginTop: -40, 
      marginLeft: 50, 
      marginRight: 50 
    }}>
      <span style={{ color: "#152d51", fontWeight: "bold" }}>Consumo (L)</span>
      <span style={{ color: "#4F46E5", fontWeight: "bold" }}>Costo ($)</span>
    </div>
  </>
);

export default FuelConsumptionChart;
